import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { GlobalToken } from 'antd';

import { useStores } from '@/hooks/use-stores';
import InsightIcon from '@/assets/icon-insight.svg?react';

const ReportHeaderWithIcon = observer(
  ({ primaryTitle, secondaryTitle }: { primaryTitle: string; secondaryTitle?: string }) => {
    const { stationStore } = useStores();

    if (!secondaryTitle) {
      const currentStation = stationStore.currentStation;
      const { customerName, name: stationName, siteName } = currentStation;
      secondaryTitle = `${customerName} | ${siteName} | ${stationName}`;
    }

    return (
      <Container>
        <div className="icon">
          <InsightIcon />
        </div>
        <div className="text">
          <div className="primary-header">{primaryTitle}</div>
          <div className="secondary-header">{secondaryTitle} </div>
        </div>
      </Container>
    );
  },
);

const Container = styled.div<{ theme: { token: GlobalToken } }>`
  border-bottom: 2px solid ${({ theme: { token } }) => token.colorBorder};
  padding-bottom: ${({ theme: { token } }) => token.padding}px;

  .icon {
    float: left;
    height: 50px;
    width: 50px;

    svg {
      height: 50px;
      width: 50px;
    }
  }

  .text {
    min-width: 300px;
    padding-left: ${({ theme: { token } }) => token.paddingXL}px;

    .primary-header {
      padding-bottom: ${({ theme: { token } }) => token.paddingXXS}px;
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
      color: ${({ theme: { token } }) => token.colorText};
    }

    .secondary-header {
      padding-top: ${({ theme: { token } }) => token.paddingXXS}px;
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      color: ${({ theme: { token } }) => token.colorBorder};
    }
  }
`;

export default ReportHeaderWithIcon;
